<template>


  <div v-if="!is_load">

    <ol class="breadcrumb">
      <li class="breadcrumb-item">Trang chủ</li>
      <li class="breadcrumb-item">
       
        <router-link to="/admin/bus/lists"> Quản lý Tuyến xe Bus</router-link>
      </li>

      <li class="breadcrumb-item">Thêm mới Tuyến xe Bus</li>
    </ol>
     <FormValidate v-slot="{ invalid ,reset }">

    <form   @submit.prevent="onSubmit" @reset.prevent="reset" id="sendform">
      
      <div class="container">
        <ul class="nav nav-tabs" role="tablist"  >
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#home"
              >Tiếng Việt</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#menu1">English</a>
          </li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">

      

          <div id="home" class="container tab-pane active">
            <br />
            <div class="">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <strong>Thông tin chung </strong>
                    <small>Form</small>
                  </div>
                  <div class="card-body">
                    <div class="row">
                     

                      <div class="col-sm-10">
                        <div class="form-group">
                          <label for="name"
                            > Tuyến xe <span class="text-danger">*</span></label
                          >
                          
                            
                           <InputValidate name="Tuyến xe " rules="required" v-slot="{ errors }">
                              <input v-model="Form.name" type="text" name="name"  class="form-control" />
                              <span class='text text-danger'>{{ errors[0] }}</span>
                            </InputValidate>
                          
                        </div>
                      </div>

                       <div class="col-sm-10">
                        <div class="form-group">
                          <label for="name"
                            > Lịch trình   <span class="text-danger">*</span></label
                          >
                          
                            
                           <InputValidate name=" Lịch trình  " rules="required" v-slot="{ errors }">
                              <input v-model="Form.schedule" type="text" name="schedule"  class="form-control" />
                              <span class='text text-danger'>{{ errors[0] }}</span>
                            </InputValidate>
                          
                        </div>
                      </div>

                     

                       
                      <div class="col-sm-10">
                        <div class="form-group">
                          <label for="name"
                            > Thời gian khởi hành   <span class="text-danger">*</span></label
                          >
                          
                            
                           <InputValidate name=" Thời gian khởi hành  " rules="required" v-slot="{ errors }">
                                <input v-model="Form.timer" type="text" name="timer"  class="form-control" />
                              <span class='text text-danger'>{{ errors[0] }}</span>
                            </InputValidate>
                          
                        </div>
                      </div>



                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="menu1" class="container tab-pane fade">

            
              
                    <div class="row">
                     

                      <div class="col-sm-10">
                        <div class="form-group">
                          <label for="name"
                            > Name <span class="text-danger">*</span></label
                          >
                          
                            
                           <InputValidate name="Tuyến xe" rules="required" v-slot="{ errors }">
                              <input v-model="Form.name_EN" type="text" name="name_en"  class="form-control" />
                              <span class='text text-danger'>{{ errors[0] }}</span>
                            </InputValidate>
                          
                        </div>
                      </div>

                      

              <div class="col-sm-10">
                        <div class="form-group">
                          <label for="name"
                            > Schedule  <span class="text-danger">*</span></label
                          >
                          
                            
                           <InputValidate name=" Lịch trình  " rules="required" v-slot="{ errors }">
                              <input v-model="Form.schedule_EN" type="text" name="schedule_en"  class="form-control" />
                              <span class='text text-danger'>{{ errors[0] }}</span>
                            </InputValidate>
                          
                        </div>
                      </div>

                     

                       
                      <div class="col-sm-10">
                        <div class="form-group">
                          <label for="name"
                            > Timer   <span class="text-danger">*</span></label
                          >
                          
                            
                           <InputValidate name=" Thời gian khởi hành  " rules="required" v-slot="{ errors }">
                                <input v-model="Form.timer_EN" type="text" name="timer_en"  class="form-control" />
                              <span class='text text-danger'>{{ errors[0] }}</span>
                            </InputValidate>
                          
                        </div>
                      </div>

                      
                       




                    </div>
          </div>
          <div
            class="card-footer"
            style="width: 90%; position: fixed; bottom: 0"
          >
            <button
              type="submit"
              class="btn btn-sm btn-primary"
             
            >
              <i class="fad fa-save"></i> Save
            </button>
             <button
              type="reset"
              class="btn btn-sm btn-warning ml-3"
              @click="myreset"
               :disabled="invalid"
            >
              <i class="fad fa-save"></i> Reset
            </button>
            
             
    
           
          </div>
        </div>
      </div>
    </form>
  </FormValidate>
  </div>
  <div v-else>
        <MyLoadTheme>
             
                <MyLoading v-for="k in 10" :key="k"></MyLoading>
           
        </MyLoadTheme>
  </div>
</template>

<script>
import axios from "axios";

  
export default {
  data() {
    return {
      is_load: false,
      img_one: "",
     
     
      list_cate: null,
      isLogin: null,
      Form: {
          id:"",
          name:'',
          schedule:"",
          timer:"",
         
          name_EN:'',
          schedule_EN:"",
          timer_EN:"",
         

      },
      

     
     
    };
  },
  created() {
    let isLogin = this.$session.get("isLogin");
    this.isLogin = isLogin.permistions.split(",");
    
  },
  
  mounted() {
          this.is_load=true;
         axios.get(window.my_api + "api/bus/get-bus-by-id", {
            params:{
              busId:this.$route.params.id
            },
            headers: window.my_header
          })
          .then((res) => {
            if (res.status == 200) {
              this.Form  = res.data.data;
              this.is_load=false;
            } else {
              alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
            }
          });

  },
  methods: {
    
    onPicturefile(e) {
      let _this = this;
      var file = e.target.files[0];
      var reader = new FileReader();
      reader.onloadend = function () {
        _this.img_one = reader.result;
      };
      reader.readAsDataURL(file);
    },
    myreset(){
        
                 Object.keys(this.Form).forEach(v => {
                      this.Form[v]="";
                  });
    },
    onSubmit: function () {
        let myForm = document.getElementById("sendform");

       let formData = new FormData(myForm);
      
       
                      
      formData.append("id",this.Form.id);


       
        
        axios
          .post(window.my_api + "api/bus/create-or-update-bus", formData, {
            headers: window.my_header,
          })
          .then((res) => {

            if (res.status == 200) {
               if(res.data.successed){
                    this.$swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Cập nhật thành công.",
                        showConfirmButton: false,
                        timer: 2500,
                      });
                      
                      
               }else{
                      this.$swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: "Vui lòng kiểm tra lại dữ liệu.",
                        showConfirmButton: false,
                        timer: 2500,
                      });
                      
                     
               }
            

            } else {
              alert("Thêm không thành công, vui lòng liên hệ admin");
             
            }
             this.is_load = false;
          });
      
    },
  },
};
</script>